import { useQuery } from "@tanstack/react-query";

import { ForecastError } from "../api/client";
import { getForecast } from "../api/forecast";
import { useSelectedLocation } from "./useSelectedLocation";
import { useUnits } from "./useUnits";

export function useForecast() {
  const { location } = useSelectedLocation();
  const { units } = useUnits();

  return useQuery({
    queryKey: ["forecast", location.lat, location.lon, units],
    queryFn: () => getForecast(location.lat, location.lon, units),
    staleTime: 5 * 60_000,
    refetchOnWindowFocus: true,
    retry: (failureCount, error) => {
      if (error instanceof ForecastError && error.status >= 400 && error.status < 500) {
        return false;
      }
      return failureCount < 1;
    },
    retryDelay: 1000,
  });
}
